import React, { useEffect, useState } from 'react';
import { loadImage } from '../../../../../lib/utils/utils';

function VariantImagePreview({ image, handleReplace, handleDelete }) {
    const [hoverOnImage, setHoverOnImage] = useState(false);
    const [visible, setVisible] = useState(false);

    const handleDeleteImage = () => {
        handleDelete(image.id);
    }

    useEffect(() => {
        if(hoverOnImage) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    }, [hoverOnImage]);

    const uniqueId = `replace-image-input-${image.id}`;

    const handleReplaceImage = async (e) => {
        setHoverOnImage(false);
        const file = e.target.files[0];

        if(file) {
            const img = await loadImage(file);
            const selectedImage = {
                id: image.id,
                url: img.src,
                file: file
            };
            handleReplace(selectedImage);
            e.target.value = null;
        }
        else {
            return;
        }
    }

    return (
        <div 
            onMouseEnter={() => setHoverOnImage(true)} 
            onMouseLeave={() => setHoverOnImage(false)} 
            className="relative w-[88px] h-[88px] rounded-xl overflow-hidden"
        >
            <img className='w-full h-full object-cover' src={image.url} alt="" />

            <div className={`${visible ? 'opacity-100 visible' : 'opacity-0 invisible'} transition-all delay-100 ease-in-out w-full h-full bg-[#00000066] absolute top-0 left-0 items-center justify-center flex flex-col gap-2`}>
                <label htmlFor={uniqueId} className='select-none bg-[#FFFFFF] w-3/4 py-[6px] text-xs font-semibold rounded text-center cursor-pointer'>Replace</label>
                
                <button onClick={handleDeleteImage} className='select-none bg-[#FFFFFF] w-3/4 py-[6px] text-xs font-semibold rounded'>Delete</button>

                <input 
                    className='hidden' 
                    id={uniqueId} 
                    type="file" 
                    accept="image/*" 
                    onChange={handleReplaceImage}
                />
            </div>
        </div>
    );
}

export default VariantImagePreview;
